// Pantalla de acceso: solo inicio de sesión. El registro está deshabilitado —
// las cuentas las asigna internamente el administrador.
import { useState, type FormEvent } from 'react';
import { useAuth } from './AuthContext';
import { Field } from '../components/Field';

export function SignIn() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);

  const enviar = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email.trim() || !password.trim()) {
      setError('Completa todos los campos.');
      return;
    }
    setCargando(true);
    const res = await signIn(email, password);
    setCargando(false);
    if (res.error) setError(res.error);
  };

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <div className="auth-brand">
          <span className="logo"><i className="fa-solid fa-cube" /></span>
          <span><b>Inventario</b><span>GESTIÓN &amp; BODEGAS</span></span>
        </div>

        <h1>Bienvenido de nuevo</h1>
        <p className="sub">Inicia sesión para continuar.</p>

        {error ? (
          <div className="auth-error"><i className="fa-solid fa-circle-exclamation" />{error}</div>
        ) : null}

        <form onSubmit={enviar}>
          <Field name="email" label="Correo electrónico" value={email} onChange={setEmail} placeholder="tucorreo@ejemplo.com" />
          <Field name="password" label="Contraseña" type="password" value={password} onChange={setPassword} placeholder="••••••••" />
          <button type="submit" className={`btn primary${cargando ? ' loading' : ''}`} style={{ width: '100%' }}>
            Iniciar sesión
          </button>
        </form>
      </div>
    </div>
  );
}
